import { ComponentType, SVGProps } from 'react';
import keyMirror from 'keymirror';

import { WrappedChapter } from '@/features/wrapped/types';

import AvatarDaygoalChampion from '@/features/wrapped/assets/images/avatar-daygoal-champion.svg?react';
import AvatarLetterPilot from '@/features/wrapped/assets/images/avatar-letter-pilot.svg?react';
import AvatarNumberSurfer from '@/features/wrapped/assets/images/avatar-number-surfer.svg?react';
import AvatarWorldTraveler from '@/features/wrapped/assets/images/avatar-world-traveler.svg?react';
import DaygoalChampionBackground from '@/features/wrapped/assets/images/player-type-daygoal-champion-background.svg?react';
import DaygoalChampionMobileBackground from '@/features/wrapped/assets/images/player-type-daygoal-champion-mobile-background.svg?react';
import LetterPilotBackground from '@/features/wrapped/assets/images/player-type-letter-pilot-background.svg?react';
import LetterPilotMobileBackground from '@/features/wrapped/assets/images/player-type-letter-pilot-mobile-background.svg?react';
import NumberSurferBackground from '@/features/wrapped/assets/images/player-type-number-surfer-background.svg?react';
import NumberSurferMobileBackground from '@/features/wrapped/assets/images/player-type-number-surfer-mobile-background.svg?react';
import WorldTravelerBackground from '@/features/wrapped/assets/images/player-type-world-traveler-background.svg?react';
import WorldTravelerMobileBackground from '@/features/wrapped/assets/images/player-type-world-traveler-mobile-background.svg?react';
import QDaygoalChampion from '@/features/wrapped/assets/images/q-daygoal-champion.svg?react';
import QLetterPilot from '@/features/wrapped/assets/images/q-letter-pilot.svg?react';
import QNumberSurfer from '@/features/wrapped/assets/images/q-number-surfer.svg?react';
import QWorldTraveler from '@/features/wrapped/assets/images/q-world-traveler.svg?react';

import type { PlayerType } from '@/features/wrapped/types';

export const wrappedActionTypes = keyMirror({
	GET_YEAR_SUMMARY_REQUEST: null,
	GET_YEAR_SUMMARY_SUCCESS: null,
	GET_YEAR_SUMMARY_ERROR: null,
});

export const CHAPTER_ORDER = [
	WrappedChapter.INTRO,
	WrappedChapter.DAYGOALS_ACHIEVED,
	WrappedChapter.MINUTES_PRACTICED,
	WrappedChapter.MATH_QUESTIONS,
	WrappedChapter.LANGUAGE_QUESTIONS,
	WrappedChapter.TOPIC_GROWTH_START,
	WrappedChapter.TOPIC_GROWTH_RESULT,
	WrappedChapter.MOST_PRACTICED_TOPICS,
	WrappedChapter.MOST_CORRECT_TOPICS,
	WrappedChapter.PLAYER_TYPE,
	WrappedChapter.PARTY_GAME,
];

interface PlayerTypeConfig {
	background: ComponentType<SVGProps<SVGSVGElement>>;
	mobileBackground: ComponentType<SVGProps<SVGSVGElement>>;
	character: ComponentType<SVGProps<SVGSVGElement>>;
	avatarCharacter: ComponentType<SVGProps<SVGSVGElement>>;
	className: string;
}

export const PLAYER_TYPE_CONFIG: Record<PlayerType, PlayerTypeConfig> = {
	day_goal_champion: {
		background: DaygoalChampionBackground,
		mobileBackground: DaygoalChampionMobileBackground,
		character: QDaygoalChampion,
		avatarCharacter: AvatarDaygoalChampion,
		className: 'wrapped-chapter--daygoal-champion',
	},
	traveller: {
		background: WorldTravelerBackground,
		mobileBackground: WorldTravelerMobileBackground,
		character: QWorldTraveler,
		avatarCharacter: AvatarWorldTraveler,
		className: 'wrapped-chapter--traveler',
	},
	math_surfer: {
		background: NumberSurferBackground,
		mobileBackground: NumberSurferMobileBackground,
		character: QNumberSurfer,
		avatarCharacter: AvatarNumberSurfer,
		className: 'wrapped-chapter--math-surfer',
	},
	letter_pilot: {
		background: LetterPilotBackground,
		mobileBackground: LetterPilotMobileBackground,
		character: QLetterPilot,
		avatarCharacter: AvatarLetterPilot,
		className: 'wrapped-chapter--letter-pilot',
	},
};

export const WRAPPED_START_DATE = '2025-12-08';
